import { ADDRESS_SCHEMA, USER_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";
import { database } from "../index";

const address = database.collections.get(ADDRESS_SCHEMA);

export const observeAddressByPhoneNumber = (number) =>
  address
    .query(
      Q.on(USER_SCHEMA, "is_active", true),
      Q.on(USER_SCHEMA, "phone_number", number)
    )
    .observe();

